import mainCaller from './mainCaller';

// 상품 목록 조회
export async function getSmsProductData(token) {
  return await mainCaller(`admin/api/v1/sms/products`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 충전 주문 생성
export async function createSmsOrder(branchId, data, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/orders`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS/LMS/MMS 단건 발송
export async function sendSms(branchId, data, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/send`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS/LMS/MMS 다건 발송 (동일 메시지를 여러 수신자에게)
export async function sendSmsBulk(branchId, data, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/send-bulk`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 충전 주문 입금 확인 (승인)
export async function confirmSmsOrder(orderId, data, token) {
  return await mainCaller(`admin/api/v1/sms/orders/${orderId}/confirm`, 'PATCH', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 충전 주문 취소 (지점, 입금대기 → 취소)
export async function cancelSmsOrder(branchId, orderId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/orders/${orderId}/cancel`, 'PATCH', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 충전 주문 거절 (총관리자, 입금대기 → 취소처리)
export async function rejectSmsOrder(orderId, token) {
  return await mainCaller(`admin/api/v1/sms/orders/${orderId}/reject`, 'PATCH', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 충전 주문 목록 조회
export async function getSmsOrderList(query, token) {
  return await mainCaller(`admin/api/v1/sms/orders?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 지점별 충전 주문 목록 조회
export async function getSmsBranchOrderList(query, token, branchId) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/orders?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// 지점 토큰 잔액 조회
export async function getSmsBalance(branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/balance`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 토큰 사용 이력(발송 내역) 조회
export async function getSmsUsageHistoryList(query, token, branchId) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/usage-history?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS (발송 내역) 조회
export async function getSmsSendHistoryList(query, token) {
  return await mainCaller(`admin/api/v1/sms/send-history?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// 템플릿 목록 조회
export async function getSmsTemplatesList(branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/templates`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 템플릿 생성
export async function createSmsTemplate(branchId, data, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/templates`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 템플릿 상세 조회
export async function getSmsTemplateDetail(branchId, templateId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/templates/${templateId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 템플릿 수정
export async function updateSmsTemplate(branchId, templateId, data, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/templates/${templateId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// SMS 템플릿 삭제
export async function deleteSmsTemplate(branchId, templateId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/templates/${templateId}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// ============================================
// SMS 발신번호 등록/인증 (총관리자)
// ============================================

// 전 지점 발신번호 통합 목록 (지점명/신청일시 포함, 검색/상태/페이징) — 총관리자 승인 화면
export async function getSmsSenderList(query, token) {
  return await mainCaller(`admin/api/v1/sms/senders?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// 지점별 발신번호 목록 (전체 상태) — 지점 등록 화면
export async function getBranchSmsSenders(branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/senders`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// 발신번호 등록 (지점 지정, 등록 직후 미인증)
export async function registerSmsSender(branchId, data, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/senders`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// 발신번호 인증 승인 (총관리자, 미인증/심사중 → 인증)
export async function approveSmsSender(id, token) {
  return await mainCaller(`admin/api/v1/sms/senders/${id}/approve`, 'POST', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// 발신번호 삭제
export async function deleteSmsSender(branchId, id, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/senders/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// 인증된 발신번호만 조회 (발송 화면 select 용)
export async function getVerifiedSmsSenders(branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/senders/verified`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// ============================================
// SMS 토큰 잔액 조정 (총관리자)
// ============================================

// 전 지점 토큰 잔액 목록 (잔액 행이 없는 지점도 0으로 내려온다)
export async function getSmsBranchBalances(query, token) {
  return await mainCaller(`admin/api/v1/sms/balances?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}

// 지점 토큰 잔액 조정 (amount 양수: 지급, 음수: 회수)
export async function adjustSmsBalance(branchId, data, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/sms/balance/adjust`, 'PATCH', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'application/json',
  });
}
